import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLoginOverlay } from "../context/LoginOverlayContext";
import "./More.css";

const More = ({
  placeholderText = "More Page (Coming Soon)",
  title = "More Content",
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, isAuthenticated } = useAuth();
  const { setShowLoginSheet } = useLoginOverlay();
  const iframeUrl = location.state?.url;

  // Hide header categories when iframe is loaded
  useEffect(() => {
    if (iframeUrl) {
      document.body.classList.add("iframe-loaded");
    } else {
      document.body.classList.remove("iframe-loaded");
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("iframe-loaded");
    };
  }, [iframeUrl]);

  const handleTutorial = () => {
    navigate("/", { state: { resetMicTooltip: true } });
  };

  const handleWhatsAppAction = () => {
    if (isAuthenticated) {
      // User is logged in - show disconnect confirmation
      if (window.confirm("Are you sure you want to unlink from WhatsApp?")) {
        logout();
        localStorage.removeItem("phoneNumber");
        navigate("/login");
      }
    } else {
      // User is not logged in - show login overlay
      setShowLoginSheet(true);
    }
  };

  return (
    <div className="more-page">
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          className="more-iframe"
          title={title}
          allowFullScreen
          allow="microphone"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
        />
      ) : (
        <div className="more-content">
          <div className="more-buttons">
            <button
              className="more-button tutorial-button"
              onClick={handleTutorial}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                  fill="currentColor"
                />
              </svg>
              <span>See Tutorial</span>
            </button>
            <button
              className="more-button disconnect-button"
              onClick={handleWhatsAppAction}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5-5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
                  fill="currentColor"
                />
              </svg>
              <span>
                {isAuthenticated
                  ? "Unlink from Phone/WhatsApp"
                  : "Link to my Phone/WhatsApp"}
              </span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default More;
